import {useEffect} from 'react';

function useBodyScroll(isOn: boolean): void {
    useEffect(() => {
        if (isOn) {
            document.body.style.overflow = 'auto';
        } else {
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOn]);
}

export default useBodyScroll;
